export enum CustomFieldTypes {
  SingleLine = "singleLine",
  MultiLine = "multiLine",
  Date = "date",
  Url = "url",
}

export const CUSTOM_FIELD_NAME = {
  [CustomFieldTypes.SingleLine]: "Single-line text",
  [CustomFieldTypes.MultiLine]: "Multi-line text",
  [CustomFieldTypes.Date]: "Date",
  [CustomFieldTypes.Url]: "Link",
};
